define('collections/base',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Collection.extend({
        limit: 10,
        offset: 0,
        query: '',
        total: null,
        fetchXhr: null,
        parameters: null,
        filters: null,

        initialize: function (models, options) {
            this.url = App.Config.apiBase + this.url;

            if (models && models.length) {
                this.set(models);
            }

            if (options && options.parameters) {
                this.parameters = options.parameters;
            }
        },

        changePage: function (pageNumber) {
            this.offset = (pageNumber-1) * this.limit;
        },

        changeOrdering: function (ordering) {
            this.ordering = ordering;
            this.offset = 0;
        },

        changeSearchQuery: function (query) {
            this.query = query;
            this.offset = 0;
        },

        changeFilter: function (key, value) {
            if (!this.filters) {
                this.filters = {};
            }

            if (value) {
                this.filters[key] = value;
            } else {
                // If parameter has no value, remove it from parameters list
                if (this.filters.hasOwnProperty(key)) {
                    delete this.filters[key];
                }
            }
        },

        getPage: function () {
          return parseInt(this.offset / this.limit) + 1;
        },

        getOrdering: function () {
          return this.ordering;
        },

        getSearchQuery: function () {
            return this.query;
        },

        getFilter: function () {
            return this.filters;
        },

        // Overriding fetch method to enable pagination
        fetch: function() {
            var _this = this;

            var parameters = {
                limit: _this.limit,
                offset: _this.offset
            };

            if (_this.ordering) {
                parameters.ordering = _this.ordering;
            }

            if (_this.query) {
                parameters.search = _this.query;
            }

            // If additional parameters supplied, add them to the request
            if (this.parameters) {
                for (var parameter in this.parameters) {
                    parameters[parameter] = this.parameters[parameter];
                }
            }

            // If there are any filter parameters, add them to the request
            for (var filterParameter in this.filters) {
                parameters[filterParameter] = this.filters[filterParameter];
            }
            $.ajax({
                url: this.url,
                type: 'GET',
                data: parameters,

                success: function(data) {
                    _this.set(data.results);
                    _this.total = data.count;

                    _this.trigger('fetch_complete');
                }
            });
        }
    });

});
